import axios from "@/plugins/axios";
import pushModel from "@/mixin/store/api/pushModel";

export default {
    actions: {
        fetchSaleCustomerMonthly(context, searchItem) {
            let url = "sale_customer_monthlies?page="  + searchItem.page + '&order[totalPurchase]=desc'

            if (!context.state.saleCustomerMonthly.isNeedFetch && !searchItem.isNeedFetch) {
                return
            }

            if (searchItem.dateTo) {
                url = url + '&date[before]=' + searchItem.dateTo
            }

            if (searchItem.dateFrom) {
                url = url + '&date[after]=' + searchItem.dateFrom
            }

            if (searchItem.companyName) {
                url = url + "&customer.customerCompany.name=" + searchItem.companyName
            }

            if (searchItem.givenName) {
                url = url + "&customer.person.givenName=" + searchItem.givenName
            }

            if (searchItem.familyName) {
                url = url + "&customer.person.familyName=" + searchItem.familyName
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateSaleCustomerMonthly', data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        fetchSaleCustomerMonthlyPurchaseCount(context, data) {
            if (!context.state.saleCustomerMonthlyPurchaseCount.isNeedFetch) {
                return
            }

            return pushModel(context, 'sale_customer_monthlies/count', data, 'updateSaleCustomerMonthlyPurchaseCount')
        },
        fetchSaleCustomerYearlyStat(context, data) {
            if (!context.state.saleCustomerYearlyStat.isNeedFetch) {
                return
            }

            return pushModel(context, 'sale_customer_monthlies/stat', data, 'updateSaleCustomerYearlyStat')
        },
    },
    mutations: {
        updateSaleCustomerMonthly(state, data) {
            state.saleCustomerMonthly = data
            state.saleCustomerMonthly.isNeedFetch = false
        },
        updateSaleCustomerMonthlyPurchaseCount(state, data) {
            state.saleCustomerMonthlyPurchaseCount.purchaseCount = data
            state.saleCustomerMonthlyPurchaseCount.isNeedFetch = false
        },
        updateSaleCustomerYearlyStat(state, data) {
            state.saleCustomerYearlyStat.monthly = data
            state.saleCustomerYearlyStat.isNeedFetch = false
        }
    },
    state: {
        saleCustomerMonthly: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
        saleCustomerMonthlyPurchaseCount: {
            purchaseCount: null,
            isNeedFetch: true
        },
        saleCustomerYearlyStat: {
            monthly: [],
            isNeedFetch: true
        }
    },
    getters: {
        getSaleCustomerMonthly(state) {
            return state.saleCustomerMonthly.models
        },
        getSaleCustomerMonthlyTotalCount(state) {
            return state.saleCustomerMonthly.totalItems
        },
        getSaleCustomerMonthlyPurchaseCount(state) {
            return state.saleCustomerMonthlyPurchaseCount.purchaseCount
        },
        getSaleCustomerYearlyStat(state) {
            return state.saleCustomerYearlyStat.monthly
        }
    },
}
